<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons left>
    <ion-button (click)="closeModal()" navPop icon-only>
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Termos de Uso' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content *ngIf="!loaded">
  <app-loading-spinner></app-loading-spinner>
</ion-content>

<ion-content *ngIf="loaded">
  <div class="trix-content" [innerHTML]="termo | safeHtml: 'html'"></div>
</ion-content>
